<div class="p-fluid p-formgrid grid compact-form" style="padding: 0.5rem!important;" [formGroup]="visit">
  <div class="p-field col-6 md:col-6 compact-form">
    <label for="rankId">Статус регистрации</label>
    <p-dropdown [options]="lstRanks" formControlName="rankId" [filter]="true" [filterBy]="'label'" (onChange)="onRankChanged($event)"
      placeholder="Выберите" [resetFilterOnHide]="true">
    </p-dropdown>
  </div>
  <div class="p-field col-6 md:col-6 compact-form">
    <label for="dateRegister">Дата регистрации</label>
    <p-calendar formControlName="dateRegister" styleClass="calendar-compact" [showIcon]="true" [showOnFocus]="false"
      dateFormat="dd-mm-yy" [showTime]="true" hourFormat="24" dataType="string" inputId="dateRegister"></p-calendar>
  </div>
  <div class="p-field col-12 md:col-12 compact-form">
    <label for="companyId">Представитель компании</label>
    <p-dropdown [style]="{height: '42px'}" [options]="lstCompanies" formControlName="companyId" placeholder="Выберите" [filter]="true"
      [filterBy]="'label'" [resetFilterOnHide]="true">
    </p-dropdown>
  </div>
  <div class="p-field col-6 md:col-6 compact-form">
    <label for="isArrive">Прибыл</label>
    <p-dropdown [options]="lstLogic" formControlName="isArrive" placeholder="Выберите" [resetFilterOnHide]="true">
    </p-dropdown>
  </div>
  <div class="p-field col-6 md:col-6 compact-form">
    <label for="dateArrive">Дата прибытия</label>
    <p-calendar formControlName="dateArrive" styleClass="calendar-compact" [showIcon]="true" [showOnFocus]="false"
      dateFormat="dd-mm-yy" [showTime]="true" hourFormat="24" dataType="string" inputId="dateArrive"></p-calendar>
  </div>
  <div class="p-field col-6 md:col-6 compact-form">
    <label for="isNeedBadge">Нужен бейдж</label>
    <p-dropdown [options]="lstLogic" formControlName="isNeedBadge" placeholder="Выберите" [resetFilterOnHide]="true">
    </p-dropdown>
  </div>
  <div class="p-field col-6 md:col-6 compact-form">
    <label for="isBadgePrinted">Напечатан бейдж</label>
    <p-dropdown [options]="lstLogic" formControlName="isBadgePrinted" placeholder="Выберите" [resetFilterOnHide]="true">
    </p-dropdown>
  </div>
</div>
